import { flexbox, layout, position, space } from "styled-system";

import { isTouch } from "../core-modules/utils";
import styled from "styled-components";

const FadeOutRollover = styled.div`
  ${flexbox}
  ${layout}
  ${position}
  ${space}
  opacity: 1;
  transition: opacity 200ms;
  font-family: ${(props) => props.theme.fonts.main};

  &:hover {
    opacity: ${() => {
      if (!isTouch()) {
        return "0.4";
      }
    }};
  }
`;

export default FadeOutRollover;
